var map = {
	"./content-folder.png": 75518,
	"./empty-folder.png": 47052,
	"./localisation.png": 83782,
	"./marketing.png": 84533,
	"./operations.png": 28863,
	"./other.png": 51324,
	"./product.png": 43075,
	"./stacked-books.png": 58316,
	"./tech.png": 81904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65351;